import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GgwDynamicRoutesComponent } from './components/ggw-dynamic-routes/ggw-dynamic-routes.component';
import {ButtonModule, DataTableModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIFormModule} from "@catuiform/ui-form.module";
import { GgwDynamicRouteTemplatesComponent } from './components/ggw-dynamic-route-templates/ggw-dynamic-route-templates.component';
import {ExplorerModule} from "@catmodules/widgets/explorer/explorer.module";
import {RouterModule} from "@angular/router";
import { GgwDynamicRouteTemplateFormComponent } from './components/ggw-dynamic-route-template-form/ggw-dynamic-route-template-form.component';
import { GgwPerformActionComponent } from './components/ggw-perform-action/ggw-perform-action.component';
import { NewGgwDynamicRouteTemplateComponent } from './components/new-ggw-dynamic-route-template/new-ggw-dynamic-route-template.component';
import {ProjectGgwDynamicRouteService} from "@catmodels/ggw-dynamic-routes/services/project-ggw-dynamic-route.service";
import { ModifyGgwDynamicRouteComponent } from './components/modify-ggw-dynamic-route/modify-ggw-dynamic-route.component';
import {
  FeatureGgwDynRouteTemplateService
} from "@catmodels/ggw-dynamic-routes/services/feature-ggw-dyn-route-templates.service";
import {GgwDynamicRouteTemplateService} from "@catmodels/ggw-dynamic-routes/services/ggw-dynamic-route-templates.service";
import {FeatureGgwDynamicRouteTemplateFormComponent} from "@catmodels/ggw-dynamic-routes/components/ggw-dynamic-route-template-form/feature-ggw-dynamic-route-template-form.component";

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    UIBaseModule,
    ButtonModule,
    FormsModule,
    UIFormModule,
    ReactiveFormsModule,
    ExplorerModule,
    RouterModule,
  ],
  declarations: [
    GgwDynamicRoutesComponent,
    GgwDynamicRouteTemplatesComponent,
    GgwDynamicRouteTemplateFormComponent,
    FeatureGgwDynamicRouteTemplateFormComponent,
    GgwPerformActionComponent,
    NewGgwDynamicRouteTemplateComponent,
    ModifyGgwDynamicRouteComponent,
  ],
  providers: [
    GgwDynamicRouteTemplateService,
    ProjectGgwDynamicRouteService,
    FeatureGgwDynRouteTemplateService
  ],
  entryComponents: [
    GgwDynamicRouteTemplateFormComponent,
    FeatureGgwDynamicRouteTemplateFormComponent,
    NewGgwDynamicRouteTemplateComponent,
    ModifyGgwDynamicRouteComponent
  ]
})
export class GgwDynamicRoutesModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/ggw-dynamic-routes.module.ts